<script setup lang="ts">
import { PropType, defineProps } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { TasksService } from "@/services/v2/tasks";
import router from "@/router/v2";

// Props
const props = defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleAbortModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
});

const handleProceed = async () => {
  props.toggleAbortModal;
  // Note: removeActiveTaskFromIndexDB method may need to be implemented
  // await TasksService.removeActiveTaskFromIndexDB();
  router.push("/dashboard/sites");
};
</script>

<template>
  <ModalBox v-if="showModal" @close="toggleAbortModal">
    <template #header> Warning! </template>
    <template #main>
      <p>Proceeding will erase your progress on the current task!</p>
    </template>
    <template #footer>
      <button @click="handleProceed" type="button"
        class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
        Proceed
      </button>
      <button @click="toggleAbortModal" type="button"
        class="text-white bg-primary hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
        Cancel
      </button>
    </template>
  </ModalBox>
</template>
